export const GET_PLP_BANNER_CONFIG = 'GET_PLP_BANNER_CONFIG';
export const GET_PLP_BANNER_CONFIG_SUCCESS = 'GET_PLP_BANNER_CONFIG_SUCCESS';
export const GET_PLP_BANNER_CONFIG_FAIL = 'GET_PLP_BANNER_CONFIG_FAIL';
export const CLEAR_PLP_BANNER_CONFIG = 'CLEAR_PLP_BANNER_CONFIG';
